// hooks/useBusDialog.js
import { useState } from "react";

export function useBusDialog() {
  const [busDialogOpen, setBusDialogOpen] = useState(false);
  const [editingJourney, setEditingJourney] = useState(null);

  const openAddBus = () => {
    setEditingJourney(null);
    setBusDialogOpen(true);
  };

  const openEditBus = (journey) => {
    setEditingJourney(journey);
    setBusDialogOpen(true);
  };

  const closeBusDialog = () => {
    setBusDialogOpen(false);
  };

  return {
    busDialogOpen,
    editingJourney,
    openAddBus,
    openEditBus,
    closeBusDialog,
  };
}